import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Card,
  CardContent,
  TablePagination,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setLimit, setSkip } from "../../redux/purchaseHistory/filterSlice";
import { useGetList } from "../../hooks/useGetList";
import formatDate from "../../utils/formatDate";

const PurchaseHistoryList = () => {
  const filter = useSelector((state) => state.purchaseHistory);
  const dispatch = useDispatch();

  const { data, loading, fetchData } = useGetList(
    `reward-purchase-history/all/list`,
    false,
  );

  const purchases = data?.data || [];
  const totalCount = data?._metadata?.total_count || data?.count || 0;

  const handleChangePage = (_, newPage) => {
    dispatch(setSkip(newPage * Number(filter?.limit || 5)));
  };

  const handleChangeRowsPerPage = (e) => {
    dispatch(setLimit(Number(e.target.value)));
    dispatch(setSkip(0));
  };

  useEffect(() => {
    fetchData(undefined, { limit: filter.limit, skip: filter.skip });
  }, [filter.limit, filter.skip]);

  return (
    <Card sx={{ mb: 4, borderRadius: 2, boxShadow: 3 }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Purchase Histories
          </Typography>
        </Box>

        {loading ? (
          <Box sx={{ textAlign: "center", py: 5 }}>
            <CircularProgress />
          </Box>
        ) : purchases.length > 0 ? (
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{ border: "1px solid #e0e0e0", overflowX: "auto" }}
          >
            <Table stickyHeader sx={{ minWidth: 900 }}>
              <TableHead>
                <TableRow
                  sx={{ "& th": { backgroundColor: "#f5f5f5", fontWeight: "bold" } }}
                >
                  <TableCell>#</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Medicine Item</TableCell>
                  <TableCell>Qty</TableCell>
                  <TableCell>Used Points</TableCell>
                  <TableCell>Remark</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {purchases.map((item, index) => {
                  const walletUser = item.relatedWalletUser;
                  const medicineItem = item.relatedMedicineItem?.relatedMedicineItem;

                  return (
                    <TableRow key={item._id || index} hover>
                      <TableCell>{(filter.skip || 0) + index + 1}</TableCell>
                      <TableCell>{formatDate(item.createdAt)}</TableCell>
                      <TableCell>{walletUser?.name || "-"}</TableCell>
                      <TableCell>{walletUser?.phone || "-"}</TableCell>
                      <TableCell>{medicineItem?.medicineItemName || "-"}</TableCell>
                      <TableCell>{item.quantity || 0}</TableCell>
                      <TableCell>{item.usedPoint?.toLocaleString() || 0}</TableCell>
                      <TableCell>{item.remark || "-"}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={totalCount}
              rowsPerPage={Number(filter?.limit || 5)}
              page={Math.floor((filter?.skip || 0) / Number(filter?.limit || 5))}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ "& p": { marginBottom: 0 } }}
            />
          </TableContainer>
        ) : (
          <Box sx={{ textAlign: "center", py: 5, color: "text.secondary" }}>
            No purchase histories found.
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PurchaseHistoryList;
